// @flow

import type {Enkeltmandat} from '../../../domain/result'

// Places enkeltmandat into table based on template
export function placeMandater(
  template: Array<Array<number>>,
  mandater: Array<Enkeltmandat>
): Array<Array<Enkeltmandat>> {
  return template.map(column => column.map(cellIndex => mandater[cellIndex]))
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/mandat-svg/index.js